import moment from 'moment-timezone';

import Admin from '../../components/Admin';
import getFilterWithCol from '../../helpers/getFilterWithCol';

import tests from '../../helpers/tests';

const {
  viewerIsNotAdmin,
} = tests;

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => {
    value = value && value.length ? value : '6419dbbe792dca00270ed5dd';
    return builder.add(
      'custom',
      { store: value },
    );
  },
  getValueForField: (value) => (
    value && value.length
    ? value
    : '6419dbbe792dca00270ed5dd' // TODO this is hardcoded to Packman®
  ),
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Store',
    allowClear: false,
    searchPaths: ['name'],
    initialValue: '6441753b308e690027f63a7d',
  }],
  skip: [
    Admin.compileFromLibrary(viewerIsNotAdmin),
  ],
}];

export const filterPeriodRange = ['FilterField', {
  id: 'periodRange',
  label: null,
  section: 'top',
  placeholder: ['From Date', 'To Date'],
  propsFromPage: props => ({
    searchParams: props.searchParams,
    history: props.history,
  }),
  ranges: {
    ...[
      ['Today', 0],
      ['Last 7 Days', 7],
      ['Last 30 Days', 30],
      ['Last 60 Days', 60],
      ['Last 90 Days', 90],
      // ['Last 180 Days', 180],
    ].reduce(
      (agr, [label, daysOffset = null]) => {
        agr[label] = () => {
          const now = moment();
          return [
            now.clone().subtract(Math.max(0, daysOffset - 1), 'days'),
            now,
          ];
        };
        return agr;
      },
      {},
    ),
    ...[
      ['Week', 'week'],
      ['Month', 'month'],
    ].reduce(
      (agr, [label, value]) => {
        agr[`This ${label}`] = [
          moment().startOf(value),
          moment().endOf(value),
        ];
        agr[`Past ${label}`] = [
          moment().subtract(1, value).startOf(value),
          moment().subtract(1, value).endOf(value),
        ];
        return agr;
      },
      {},
    ),
  },
  buildQuery: (value, builder, _1, _2) => {
    const now = moment();
    const date = new Date();
    if (
      value
      && value.length
    ) {
      const values = (
        value
        .split(',')
        .map(dateString => (
          moment(dateString, 'YYYY-MM-DD')
          .hour(now.hour())
          .minute(now.minute())
          .second(now.second())
          .millisecond(now.millisecond())
        ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        builder.add('custom', {
          periodDateStart: values[0].toJSON(),
          periodDateEnd: values[1].toJSON(),
          periodDateNow: new Date(date.getTime()),
          timezoneOffset: (date.getTimezoneOffset() * 60 * 1000),
          timezone: moment.tz.guess(),
          periodSpan: 'custom',
        });
        return;
      }
    }
    builder.add('custom', {
      periodDateStart: now.clone().subtract(6, 'days').toJSON(),
      periodDateEnd: now.toJSON(),
      periodDateNow: new Date(date.getTime()),
      timezoneOffset: (date.getTimezoneOffset() * 60 * 1000),
      timezone: moment.tz.guess(),
      periodSpan: 'custom',
    });
  },
  getValueForField: (value) => {
    const now = moment();
    if (value && value.length) {
      const values = (
        value
        .split(',')
        .map(dateString => (
          moment(dateString, 'YYYY-MM-DD')
          .hour(now.hour())
          .minute(now.minute())
          .second(now.second())
          .millisecond(now.millisecond())
        ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        return values;
      }
    }
    return [
      now.clone().subtract(6, 'days'),
      now,
    ];
  },
  getValueForQuery: (value) => {
    if (
      Array.isArray(value)
      && value.length === 2
      && value[0] && value[0].isValid()
      && value[1] && value[1].isValid()
    ) {
      return `${
        value[0].format('YYYY-MM-DD')
      },${
        value[1].format('YYYY-MM-DD')
      }`;
    }
    return undefined;
  },
  field: ['FieldDateRangePicker', {
    id: 'periodRange',
    name: 'periodRage',
    format: 'll',
    showToday: false,
    separator: '-',
  }],
}];

export const ADMIN_ALL = [
  ...[
    [filterStore, 24],
    [filterPeriodRange, 24],
  ].map(args => getFilterWithCol(...args)),
];
